import React from 'react';
import { InfoCircleFill } from '@styled-icons/bootstrap/InfoCircleFill';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
export const TooltipWrapper = styled.div `
  .tooltip {
    background: #fff;
    color: ${({ theme }) => theme.palette.grey['A800']};
    max-width: 200px;
    box-shadow: rgb(0 0 0 / 11%) 0px 2px 16px 0px;
    opacity: 1;
    border-radius: 3px;
    line-height: 1.2;
    padding: 8px 10px;
  }
`;
const Tooltip = ({ children, tooltipText }) => {
    return (React.createElement(TooltipWrapper, { "data-tip": tooltipText, "data-iscapture": "true" },
        !!children ? (React.createElement("span", null, children)) : (React.createElement("div", null,
            React.createElement(InfoCircleFill, { size: 20, color: "#D7D7D7" }))),
        React.createElement(ReactTooltip, { multiline: true, effect: "solid", className: "tooltip", arrowColor: "transparent" })));
};
export default Tooltip;
